export default __webpack_public_path__ + "static/media/img--interiors-9.debcbe22.jpg";